export class MedmalPromoMdl
{
   public  DICOUNTFLAG: boolean;
   public  DISCOUNT_PER: number;
   public  DISCOUNT_FLAT: number;
   public PROMOID:number;
   public DISCOUNTTYPE:string;
   
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/MedmalPromoMdl.ts